const ENDPOINT =
  "https://cooperandco.com.au/apps/datajet/task/69d4e128649e91cf20d321ae";

function togglePincode() {
  const box = document.getElementById("pincodeBox");
  if (box) box.classList.toggle("active");
}

function getCurrentSKU() {
  const variantId = document.querySelector('[name="id"]')?.value;
  const variants = window.ShopifyAnalytics?.meta?.product?.variants;

  if (variants && variantId) {
    const variant = variants.find(v => v.id == variantId);
    if (variant?.sku) return variant.sku;
  }

  return typeof currentSKU !== "undefined" ? currentSKU : "";
}

function getQty() {
  const input = document.querySelector('[name="quantity"]');
  const qty = parseInt(input?.value, 10);
  return qty > 0 ? qty : 1;
}

function checkDelivery() {
  const input = document.getElementById("shipping_estimator_postcode");
  const btn = document.getElementById("shipping-estimator-btn");
  const loader = document.getElementById("shipping-loader");
  const result = document.getElementById("result");
  const error = document.getElementById("pincodeError");

  const postcode = input?.value.trim();
  const sku = getCurrentSKU();
  const quantity = getQty();

  if (!/^\d{4}$/.test(postcode)) {
    error.textContent = "Please enter a valid postcode";
    error.style.display = "block";
    result.innerHTML = "";
    return;
  }

  error.style.display = "none";
  result.innerHTML = "";
  loader.style.display = "block";

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      postcode,
      sku,
      variantId: btn.dataset.variantId,
      quantity
    })
  })
    .then(res => {
      if (!res.ok) throw new Error("Request failed");
      return res.json();
    })
    .then(data => {
      console.log(data);
      loader.style.display = "none";

      if (
        data.error ||
        !Array.isArray(data.rates) ||
        !data.rates.length
      ) {
        result.classList.add("error");
        result.innerHTML =
          "Services not available for this postcode";
        return;
      }

      result.classList.remove("error");

      finalOutput(data, {
        expectedDate: btn.dataset.expectedShipmentDate,
        estimatedMsg: btn.dataset.estimatedMsg,
        productPreorder: btn.dataset.productPreorder,
        productAvailable: btn.dataset.productAvailability
      });
    })
    .catch(error => {
      console.error("Shipping error:", error);
      loader.style.display = "none";
      result.classList.add("error");
      result.innerHTML = "Something went wrong";
    });
}

function finalOutput(data, settings) {
  const result = document.getElementById("result");

  const postcode = data.postcode || "";
  const state = data.state || "";
  const rates = data.rates || [];

  let rate = rates.find(r =>
    r.name?.includes("Standard")
  );

  if (!rate) {
    rate = rates.find(r =>
      r.name?.includes("Premium")
    );
  }

  if (!rate) rate = rates[0];

  const zoneDays = {
    zone_1: [3, 5],
    zone_2: [3, 6],
    zone_3: [3, 6],
    zone_4: [3, 7],
    zone_5: [4, 7],
    zone_6: [4, 9],
    zone_7: [3, 6],
    zone_8: [4, 8],
    zone_9: [5, 8],
    zone_10: [7, 12],
    zone_11: [8, 13],
    zone_12: [4, 8]
  };

  const zoneKey = (data.zone || "")
    .toLowerCase()
    .replace(/\s+/g, "_");

  const days = zoneDays[zoneKey];

  let deliveryText = "";

  if (days) {
    let today = new Date();
    const shipmentDate = new Date(settings.expectedDate);

    if (
      settings.productPreorder &&
      !isNaN(shipmentDate.getTime())
    ) {
      today = shipmentDate;
    }

    const dispatch = addBusinessDays(today, 1);
    const min = addBusinessDays(dispatch, days[0]);
    const max = addBusinessDays(dispatch, days[1]);

    const options = {
      day: "numeric",
      month: "short"
    };

    deliveryText =
      `${min.toLocaleDateString("en-GB", options)} - ` +
      `${max.toLocaleDateString("en-GB", options)}`;
  }

  const price =
    rate?.price != null
      ? formatMoney(Number(rate.price) * 100)
      : "";

  result.innerHTML = `
    <div class="delivery-result">
      <div class="delivery-result--item">
        <strong>Delivering to: ${state}, ${postcode}</strong>
      </div>

      ${
        price
          ? `
            <div class="delivery-result--item">
              <p>${rate.name}:</p>
              <p>${price}</p>
            </div>
          `
          : ""
      }

      <div class="delivery-result--item">
        <p>${settings.estimatedMsg || ""}</p>
        <p>${deliveryText}</p>
      </div>
    </div>
  `;
}

function addBusinessDays(date, days) {
  const result = new Date(date);
  let count = 0;

  while (count < days) {
    result.setDate(result.getDate() + 1);

    if (
      result.getDay() !== 0 &&
      result.getDay() !== 6
    ) {
      count++;
    }
  }

  return result;
}

function formatMoney(cents, format = "") {
  const moneyFormat =
    format ||
    window.themeVariables?.settings?.moneyFormat ||
    "${{amount}}";

  const value = (Number(cents) / 100).toFixed(2);

  return moneyFormat.replace(
    /\{\{\s*amount\s*\}\}/,
    value
  );
}

document.addEventListener("change", function (e) {
  if (e.target.name === "id") {
    const result = document.getElementById("result");
    if (result) result.innerHTML = "";
  }
});
